class AboutController {
    constructor($window, $browser, $location, AppServiceApi, RouteService) {
        this.$onInit = () => {
            this.init();
        };
        this.init = () => {
            this.data = {};
            this.AppServiceApi.systemInfo().then((response) => {
                this.data = response.data;
            });
            this.route = this.Route();
        };
        this.showSupportMessage = () => {
            if (this.data.AboutSupportMessage !== '') {
                return true;
            }
            else {
                return false;
            }
        };
        this.showSupportLink = () => {
            if (this.data.AboutSupportLink !== '') {
                return true;
            }
            else {
                return false;
            }
        };
        this.Route = () => {
            this.RouteService.buildRoute('TeamAdmin').then((route) => {
                return route;
            });
        };
        this.window = $window;
        this.browser = $browser;
        this.location = $location;
        this.AppServiceApi = AppServiceApi;
        this.RouteService = RouteService;
    }
}
angular.module('app').component('about', {
    templateUrl: 'Scripts/App/partials/about/about.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: AboutController
});
